<template>
  <div class="container">
    <el-dialog
      width="99%"
      title="历史标签"
      :visible.sync="printInfoDialogVisible"
      center
      @opened="openedPrintDialog"
      @closed="closedPrintDialog">
      <el-form size="small" @submit.native.prevent inline :rules="printRules" :model="printForm" ref="refPrintForm">
        <el-form-item label="Tracking NO:">
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="printForm.trayNo"
            @keyup.enter.native="handleEnterTrackingNo"
            @clear="clearTrackingNo"
            tabindex="1">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loadingPrint"
            type="primary"
            @click="submitPrintForm">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <printInfoListTable
        :data="printInfoList"
        :machineHandNoArray="machineHandNoArray"
        @print="printDetail"
        @updateLabel="updateLabel"
      />
      <pagination
        :total="printCount"
        :pageSize="printPerpage"
        :current-page.sync="printPage"
        @current-change="onChangePrintPage"
      />
    </el-dialog>
    <el-form @submit.native.prevent class="form" :model="form" :rules="rules" ref="refForm" label-width="150px">
      <el-form-item label="订单子批号:" prop="subNo"
                    style="width: 400px;">
        <subNoInputList
          ref="refSubNo"
          v-model.trim="form.subNo"
          :pageName="pageName"
          @enter="handleEnter"
          popoverWidth="230"
        />
      </el-form-item>
      <el-form-item label="满盘数量:" prop="count" style="width: 400px;">
        <el-input
          ref="refCount"
          v-model.trim.number="form.count"
          type="tel"
          autocomplete="off"
          clearable
          maxlength="20"
          @change="changeCount">
        </el-input>
      </el-form-item>
      <el-form-item label="档位:" prop="binLevel" style="width: 400px;">
        <el-select
          filterable
          v-model.trim.number="form.binLevel"
          style="width: 100%;"
          @change="changeBinLevel">
          <el-option
            v-for="(item, i) in passBinLevels"
            :key="i"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分选机编号:" prop="machineHandNo" style="width: 400px;">
        <el-select
          filterable
          v-model.trim="form.machineHandNo"
          style="width: 100%;"
          @change="changeMachineHandNoLevel">
          <el-option
            v-for="(item, i) in machineHandNoArray"
            :key="i"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: 20px;">
        <el-button
          type="plain"
          @click="getLabel">
          历史标签
        </el-button>
        <el-button
          :loading="loadingMain"
          type="primary"
          @click="submitForm">
          打印标签
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import printInfoListTable from './printInfoListTable';
  import subNoInputList from './subNoInputList';
  import pagination from './pagination';
  import {isPositiveIntegerNum, getQueryVariable} from '@/utils';
  import {generateBinLevelValue, printLabel} from '@/utils/label';
  import {trackingInfo} from '@/api/box';
  import {createLabel, getLabel, updateLabel} from '@/api/label';
  import {passBinLevels} from '@/utils/defines';

  export default {
    components: {
      printInfoListTable,
      subNoInputList,
      pagination,
    },
    props: {
      machineHandNoArray: Array,
    },
    data() {
      let validateCount = (rule, value, callback) => {
        if (value === '' || value === undefined) {
          callback('满盘数量不能为空');
          return;
        }
        if (!isPositiveIntegerNum(value)) {
          callback(new Error('满盘数量必须是正整数'));
          return;
        }
        callback();
      };
      let validateTrackingNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          callback();
          return;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          callback(new Error(`Tracking NO格式错误`));
          return;
        }
        callback();
      };
      return {
        rules: {
          subNo: [{required: true, message: '请输入订单子批号', trigger: 'submit'}],
          count: [{required: true, validator: validateCount, trigger: 'submit'}],
          binLevel: [{required: true, message: '请选择档位', trigger: 'submit'}],
          machineHandNo: [{required: true, message: '请选择分选机编号', trigger: 'submit'}],
        },
        form: {
          subNo: '',
          count: 3500,
          binLevel: 1,
          machineHandNo: undefined,
        },
        printRules: {
          trayNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
        },
        printForm: {
          trayNo: undefined,
        },
        searchParams: {
          trayNo: undefined,
        },
        loadingPrint: false,
        loadingMain: false,
        listData: [],
        editIndex: -1,
        printInfoList: [],
        printInfoDialogVisible: false,
        printPage: 1,
        printPerpage: 20,
        printCount: 0,
        pageName: 'labelPrint',
        passBinLevels,
      }
    },
    computed: {
      ...mapGetters([
        'labelPrintCountObj',
        'subNoListObj',
        'binLevelObj',
        'machineHandNoObj',
        'queryMachineHandNoUsedObj',
      ]),
    },
    watch: {
      $route: {
        handler() {
          this.queryMachineHandNo({isRouterChange: true});
        },
      },
    },
    mounted() {
      const {
        machineHandNoArray,
        pageName,
      } = this;
      let defaultMachineHandNo = machineHandNoArray && machineHandNoArray.length > 0 ? machineHandNoArray[0] : undefined;
      this.form.count = this.labelPrintCountObj[pageName] || 3500;
      this.form.binLevel = this.binLevelObj[pageName] || 1;
      this.form.machineHandNo = this.machineHandNoObj[pageName] || defaultMachineHandNo;
      this.$refs.refSubNo && this.$refs.refSubNo.focus();
      this.scanBoxInfoBarCode();
      this.queryMachineHandNo();
    },
    methods: {
      queryMachineHandNo({isRouterChange = false} = {}) {
        const {
          queryMachineHandNoUsedObj,
          pageName,
          machineHandNoArray,
        } = this;
        const machineHandNo = getQueryVariable('machineHandNo');
        if (machineHandNo && machineHandNoArray) {
          if (machineHandNoArray.includes(machineHandNo)) {
            if (!queryMachineHandNoUsedObj[pageName] || isRouterChange) {
              this.form.machineHandNo = machineHandNo;
              this.queryMachineHandNoUsedObj[pageName] = true;
              this.$store.commit('label/saveQueryMachineHandNoUsedObj', this.queryMachineHandNoUsedObj);
              this.machineHandNoObj[pageName] = machineHandNo;
              this.$store.commit('label/saveMachineHandNoObj', this.machineHandNoObj);
            }
          }
        }
      },
      async getLabel() {
        this.loadingPrint = true;
        try {
          const res = await getLabel({
            page: this.printPage,
            perpage: this.printPerpage,
            result: true,
            keyword: this.searchParams.trayNo || undefined,
          });
          const data = res.data;
          this.printInfoDialogVisible = true;
          this.printInfoList = data.info;
          if (data.count !== undefined) {
            this.printCount = data.count;
          }
        } catch (e) {
        } finally {
          this.loadingPrint = false;
        }
      },
      onChangePage() {
        this.editIndex = -1;
        this.getLabel();
      },
      handleEnterTrackingNo() {
        this.submitPrintForm();
      },
      clearTrackingNo() {
        this.submitPrintForm();
      },
      submitPrintForm() {
        this.$refs.refPrintForm.validate(async (valid) => {
          if (valid) {
            this.printPage = 1;
            this.searchParams = {...this.printForm};
            this.getLabel();
          }
        });
      },
      handleEnter() {
        this.submitForm();
      },
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode;
        document.onkeypress = (e) => {
          nextCode = e.which;
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.printInfoDialogVisible) {
              if (this.loadingPrint) {
              } else if (this.$refs.refTrayNo && this.$refs.refTrayNo.focused) {
              } else {
                this.printForm.trayNo = code;
                this.submitPrintForm();
              }
            } else if (this.loadingMain) {
            } else if (this.$refs.refSubNo && this.$refs.refSubNo.focused) {
              if (this.form.count) {
              } else {
                this.$refs.refCount && this.$refs.refCount.focus();
              }
            } else if (this.$refs.refCount && this.$refs.refCount.focused) {
            } else {
              this.form.subNo = code;
              if (this.form.count) {
                this.submitForm();
              } else {
                this.$refs.refCount && this.$refs.refCount.focus();
              }
            }
            code = '';
          }
        };
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.createLabel();
          }
        });
      },
      async createLabel() {
        const {
          subNo,
          count,
          binLevel,
          machineHandNo,
        } = this.form;
        this.loadingMain = true;
        this.form.subNo = undefined;
        try {
          const res = await trackingInfo({subNo});
          const data = res.data;
          const {
            id,
            productName,
            chipName,
          } = data;
          const resLabel = await createLabel({
            lotNoInfo: JSON.stringify([{
              incoOrdersDetailId: id,
              count: Number.parseInt(count, 10),
            }]),
            binLevel: Number.parseInt(binLevel, 10),
            machineHandNo,
          });
          let binLevelValue = generateBinLevelValue({productName, chipName, binLevel});
          const dataLabel = resLabel.data;
          this.saveSubNoInputList(subNo);
          printLabel({...dataLabel, binLevelExplain: binLevelValue});
        } catch (e) {
          // do nothing.
        } finally {
          this.loadingMain = false;
        }
      },
      saveSubNoInputList(subNo) {
        const subNoListObj = this.subNoListObj;
        const pageName = this.pageName;
        const subNoList = subNoListObj[pageName] || [];
        const findIndex = subNoList.findIndex(item => item === subNo);
        if (findIndex === -1) {
          subNoList.unshift(subNo)
        }
        const isMoreThan9 = subNoList && subNoList.length > 9;
        if (isMoreThan9) {
          subNoList.pop();
        }
        subNoListObj[pageName] = subNoList;
        this.$store.commit('label/saveSubNoListObj', {...subNoListObj});
      },
      printDetail(labelData) {
        printLabel(labelData);
      },
      async onChangePrintPage() {
        this.getLabel();
      },
      async updateLabel({id, partNo, partNoSuffix, trackingNo, dateCode, lotNoInfo, binLevel, machineHandNo = undefined}) {
        try {
          await updateLabel({
            labelId: id,
            partNo: partNo + partNoSuffix,
            trackingNo,
            dateCode,
            lotNoInfo: JSON.stringify(lotNoInfo),
            binLevel: Number.parseInt(binLevel, 10),
            machineHandNo,
          });
          this.$message({
            type: 'success',
            message: '更新成功',
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.getLabel();
        }
      },
      changeCount(val) {
        if (isPositiveIntegerNum(val)) {
          const pageName = this.pageName;
          this.labelPrintCountObj[pageName] = Number.parseInt(val, 10);
          this.$store.commit('label/saveLabelPrintCountObj', this.labelPrintCountObj);
        }
      },
      changeBinLevel(val) {
        const pageName = this.pageName;
        this.binLevelObj[pageName] = Number.parseInt(val, 10);
        this.$store.commit('label/saveBinLevelObj', this.binLevelObj);
      },
      changeMachineHandNoLevel(val) {
        const pageName = this.pageName;
        this.machineHandNoObj[pageName] = val;
        this.$store.commit('label/saveMachineHandNoObj', this.machineHandNoObj);
      },
      openedPrintDialog() {
        this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      },
      closedPrintDialog() {
        this.printForm.trayNo = undefined;
        this.$refs.refPrintForm && this.$refs.refPrintForm.clearValidate();
        this.$refs.refSubNo && this.$refs.refSubNo.focus();
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    text-align: center;
  }

  .form {
    margin-top: 40px;
    text-align: center;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
  }

  .separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }

</style>
